// src/pages/RoleManagement/modals/DeleteRoleDialog.tsx
// Delete confirmation dialog for role groups

import React from 'react';
import { Modal, ModalBody, Button } from 'reactstrap';
import { useLocation } from 'react-router-dom';
import { RoleGroup } from '../types';
import { PageActionPermission } from 'services/pageActionPermission/PageActionPermission';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('role_management');

interface DeleteRoleDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
  roleGroup: RoleGroup | null;
}

const DeleteRoleDialog: React.FC<DeleteRoleDialogProps> = ({
  isOpen,
  onClose,
  onDelete,
  roleGroup,
}) => {
  const location = useLocation();
  // Check if role can be deleted — khớp đúng rule backend (DeleteRoleCommand.cs: VR-RG-011/VR-RG-012),
  // không có rule riêng cho code 'ADMIN' như trước (backend không chặn theo code).
  const canDelete = roleGroup && !roleGroup.isProtected && !roleGroup.isDefault;

  if (!roleGroup) return null;

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered>
      <ModalBody className="py-3 px-5">
        <div className="mt-2 text-center">
          <i className="ri-delete-bin-line display-5 text-danger"></i>
          <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            {canDelete ? (
              <>
                <h4>{st('xac_nhan_xoa_nhom_quyen_title')}</h4>
                <p className="text-muted mb-3">
                  {st('ban_co_chac_muon_xoa_nhom_text')} <strong>{roleGroup.name}</strong>?
                </p>

                {roleGroup.userCount > 0 && (
                  <div className="alert alert-warning mb-0">
                    <i className="ri-alert-line me-2"></i>
                    {st('nhom_quyen_nay_co_text')} <strong>{roleGroup.userCount} {st('thanh_vien_text')}</strong>{st('viec_xoa_nhom_quyen_nay_se_text')}
                  </div>
                )}
              </>
            ) : (
              <>
                <h4>{st('khong_the_xoa_title')}</h4>
                <div className="alert alert-danger mb-0">
                  <i className="ri-error-warning-line me-2"></i>
                  <strong>{st('khong_the_xoa_nhom_quyen_nay_text')}</strong>
                  <br />
                  {roleGroup.isProtected
                    ? st('day_la_nhom_quyen_he_thong_text')
                    : st('day_la_nhom_quyen_mac_dinh_text')}
                </div>
              </>
            )}
          </div>
        </div>
        <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
          <Button
            type="button"
            color="light"
            className="w-sm"
            onClick={onClose}
          >
            {st('huy_button')}
          </Button>
          {canDelete && PageActionPermission.canDisplay(location.pathname, "button-delete-confirm") && (
            <Button
              type="button"
              color="danger"
              className="w-sm"
              data-action-code="button-delete-confirm"
              data-action-name="Xác nhận xóa nhóm quyền"
              onClick={onDelete}
            >
              {st('xoa_nhom_quyen_label')}
            </Button>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default DeleteRoleDialog;
